export default __webpack_public_path__ + "static/basePersonajePenis-a06e7ff1d0965da3e50b1e1f123c5091.png";